import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBtmifA18uJyqwAkiRvkwPPmlei_F2-B8Y",
  authDomain: "project-0b8d6e7a-03cf-4165-acc.firebaseapp.com",
  projectId: "project-0b8d6e7a-03cf-4165-acc",
  storageBucket: "project-0b8d6e7a-03cf-4165-acc.firebasestorage.app",
  messagingSenderId: "255115267503",
  appId: "1:255115267503:web:2ca9a32f0c469b08eff35a"
};

const app      = initializeApp(firebaseConfig);
export const auth     = getAuth(app);
export const provider = new GoogleAuthProvider();

export async function signInWithGoogle() {
  const result = await signInWithPopup(auth, provider);
  return result.user;
}

export async function signOutUser() {
  await signOut(auth);
}

export async function getIdToken() {
  const user = auth.currentUser;
  if (!user) return null;
  return user.getIdToken();
}
